import { CONTACT_EMAIL } from "../lib/site";
import { Body, Em, GOLD_DEEP, GoldBtn, HAIR, IVORY, Kicker, Ornament, Section, Serif, Title } from "../components/ms/kit";
import { useInvite } from "../components/ms/InviteContext";
import PageShell from "../components/ms/PageShell";

const Detail = ({ label, children, testId }) => (
  <div className="py-7 text-center" style={{ borderBottom: HAIR }}>
    <p className="text-[10.5px] tracking-[0.32em] uppercase" style={{ color: GOLD_DEEP }}>{label}</p>
    <div className="mt-3" style={{ ...Serif, color: IVORY, fontSize: "clamp(1.3rem, 2.4vw, 1.75rem)" }} data-testid={testId}>{children}</div>
  </div>
);

export default function Contact() {
  const openInvite = useInvite();
  return (
    <PageShell testId="contact-page">
      <Section className="pt-28 md:pt-40 pb-32 md:pb-44" width="max-w-3xl" testId="contact-section">
        <div className="text-center">
          <Kicker>Contact</Kicker>
          <Title as="h1" size="lg" className="mt-8 leading-[0.98]" testId="contact-headline">Start a <Em>conversation.</Em></Title>
          <Body className="mt-10 max-w-xl mx-auto">Whether you are an investor, a fund manager, a founder or a partner, we would love to hear from you.</Body>
          <Ornament />
        </div>
        <div className="mt-10" style={{ borderTop: HAIR }}>
          <Detail label="Email" testId="contact-email">
            <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors hover:text-white">{CONTACT_EMAIL}</a>
          </Detail>
          <Detail label="Location" testId="contact-location">Regina, Saskatchewan</Detail>
        </div>
        <div className="mt-14 text-center"><GoldBtn onClick={openInvite} testId="contact-cta-invite">Request Invitation</GoldBtn></div>
      </Section>
    </PageShell>
  );
}
